import { render, staticRenderFns } from "./Metric.vue?vue&type=template&id=0f6a22bc&scoped=true"
import script from "./Metric.vue?vue&type=script&lang=ts"
export * from "./Metric.vue?vue&type=script&lang=ts"
import style0 from "./Metric.vue?vue&type=style&index=0&id=0f6a22bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a22bc",
  null
  
)

export default component.exports